import config from "@/config";
import http from "@/utils/request";

const api = (path) => `${config.API_URL}${path}`;

export default {
	list: {
		url: api("/admin/live_water_army/list"),
		name: "水军账号列表",
		get(params) {
			return http.get(this.url, params);
		},
	},
	info: {
		url: api("/admin/live_water_army/info"),
		name: "水军账号详情",
		get(params) {
			return http.get(this.url, params);
		},
	},
	save: {
		url: api("/admin/live_water_army/save"),
		name: "保存水军账号",
		post(params) {
			return http.post(this.url, params);
		},
	},
	delete: {
		url: api("/admin/live_water_army/delete"),
		name: "删除水军账号",
		post(params) {
			return http.post(this.url, params);
		},
	},
};
